"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeBrandString = exports.brandString = void 0;
/**
 * Brands a string with the specified brand.
 *
 * @param s The string to brand.
 */
function brandString(s) {
    return s;
}
exports.brandString = brandString;
/**
 * Returns a function that brands a string with the specified brand.  For
 * example:
 *
 * ```ts
 * type Apple = BrandedString<"apple">;
 * // `makeApple` will be of type `(s: string) => Apple`
 * const makeApple = makeBrandString<Apple>();
 * // `apple` will be of type `Apple`
 * const apple = makeApple("Pink Lady");
 * ```
 */
function makeBrandString() {
    return brandString;
}
exports.makeBrandString = makeBrandString;
